module.exports = __webpack_public_path__ + "img/logo-min.78a52160.svg";